import { getSendToMQBytes, bytesToBase64 } from '../lib/classTalk/EncodeDecode'; // 20261015 bytesToBase64 추가
import i18n from '../locales/config'; // 20261015 음성메모 전송 실패 알림 문구용
import { enTokenCMD } from '../lib/classTalk/CodeEnum';

import { getDefaultDirectKey, getHandsUpBindKey, getHandsUpSendKey, getTeamUpBindKey, getTeamUpSendKey } from '../lib/rbmq/rbmqKey';
import ConstData from './ConstData';

const amqExchange = { name: "amq.topic", kind: "topic" };

//로그인시 eo브라우져에게 전달
const convertMQ_Info = (info) => {
    return ({
        action: "connection",
        exchange: info.EXCH_NAME,
        host: info.SVER_IP,
        port: info.SVER_PORT_NEW,   // SVER_PORT_NEW 가 다시 5672임
        // port: info.SVER_PORT,    // 20250319 rabbitmq 서버에 로컬 서버 연결 오류로 인해 새로운 포트 변경 적용 ... by hjkim
        mqttPort: info.MQTT_PORT ? info.MQTT_PORT : null,
        wsIp: info.WSVER_IP,
        wsPort: info.WSVER_PORT,
        wsPath: info.WSVER_PATH,
        vHost: info.VRTL_HOST,
        userName: info.USER_ID,
        passWord: info.PSWD,
    });
}

export const callEoForLogin = (rbmq_info, user_info, mode, gateWay, version, list_service, mainAddurl, contentTeacher_info) => {
    const userSeq = user_info.USER_SEQ;
    let temp = mode === "hiclass" ? 1 : 0;

    const connectInfo = convertMQ_Info(rbmq_info);
    connectInfo.exchanges = [amqExchange];

    const key = getDefaultDirectKey(userSeq, temp);
    const keyArr = getHandsUpBindKey(userSeq, 0);

    const infos = [{ exchange: amqExchange.name, key }];

    if (Array.isArray(keyArr)) {
        for (let i = 0; i < keyArr.length; i++) {
            infos.push({ exchange: amqExchange.name, key: keyArr[i] });
        }
    }

    const bindInfo = {
        action: "bind",
        infos,
        topicSendKeyLC: getHandsUpSendKey(userSeq, 0, 0)
    };

    let isRealYn = ConstData.IS_DEV_VALUE ? 'N' : 'Y';
    let isLocalYn = ConstData.IS_LOCAL_VERSION ? 'Y' : 'N';

    console.log("callEoForLogin isRealYn: ", isRealYn, ", isLocalYn: ", isLocalYn);

    const callData = {
        userSeq,
        userName: user_info.USER_NICKNAME,
        routingKey: key,
        userGateWay: gateWay,
        version, list_service,
        isLocalYn,
        isRealYn,
        handsUpUrl: mainAddurl,
        contentTeacherSeq: contentTeacher_info.contentTeacherSeq,
        contentTeacherNickname: contentTeacher_info.contentTeacherNickname
    };

    sendToBrowserMediaScreen(
        JSON.stringify({ connectInfo, bindInfo }),
        JSON.stringify({ callKind: "initMediaSoup", callData })
    );
}

export const callEoForLogout = (userSeq, mode) => {
    let temp = mode === "hiclass" ? 1 : 0;
    const keyArr = getHandsUpBindKey(userSeq, 0);
    const infos = [{ exchange: amqExchange.name, key: getDefaultDirectKey(userSeq, temp) }];

    if (Array.isArray(keyArr)) {
        for (let i = 0; i < keyArr.length; i++) {
            infos.push({ exchange: amqExchange.name, key: keyArr[i] });
        }
    }

    const bindInfo = {
        action: "unbind",
        infos,
        topicSendKeyLC: "RESET"
    };

    sendToBrowserMediaScreen(JSON.stringify({ connectInfo: { action: "disconnection" }, bindInfo }), JSON.stringify({ callKind: "closeMediaSoup" }));
}

// 260909 Pro 가 mixed 세션(LessonTarget)을 세우는 데 쓰는 값을 같이 싣는다 ... by hjkim
// 통지 82 §4 · Pro 회신 232 §3 - Pro 는 startResult/stopResult 만 읽는데 거기엔 1001 과 1 뿐이라
// mixedClassSeq(=mixed.program.{번호}.command 의 번호)를 받을 통로가 없었다.
// create 는 그 번호를 만들어 내는 요청이라 이 시점엔 아직 없다 - localServerSeq 만 싣는다.
export const callEoForCreateMixedClass = (serverUserSeq, localUserSeq, localLiveSeq, localServerSeq) => {
    const callData = { actionKind: "create", serverUserSeq, localUserSeq, localLiveSeq, localServerSeq };
    sendToBrowserMediaScreen("", JSON.stringify({ callKind: "mixedClassAction", callData }));
}

export const callEoForDeleteMixedClass = (localUserSeq, localLiveSeq) => {
    const callData = { actionKind: "delete", localUserSeq, localLiveSeq };
    sendToBrowserMediaScreen("", JSON.stringify({ callKind: "mixedClassAction", callData }));
}

// 260909 mixedClassSeq 가 필요한 것은 여기다 - start 로 mixed 가 뜰 때 Pro 가 그 번호로 붙는다 ... by hjkim
export const callEoForUpdateMixedClassStatus = (kind, serverUserSeq, localUserSeq, localLiveSeq, mixedClassSeq, localServerSeq) => {
    const callData = { actionKind: kind, serverUserSeq, localUserSeq, localLiveSeq, mixedClassSeq, localServerSeq };
    sendToBrowserMediaScreen("", JSON.stringify({ callKind: "mixedClassAction", callData }));
}

export const callEoForSendMixedClassMailLink = (localLiveSeq, liveName, liveTeacherNickname, list_member) => {
    const callData = { actionKind: "sendMailLink", localLiveSeq, liveName, liveTeacherNickname, list_member };
    sendToBrowserMediaScreen("", JSON.stringify({ callKind: "mixedClassAction", callData }));
}

export const callEoForRequestServerUserAuth = (localUserSeq, serverUserID, serverUserPW, isKeepSaving) => {
    const callData = { actionKind: "requestAuth", localUserSeq, serverUserID, serverUserPW, isKeepSaving };
    console.log(callData);
    sendToBrowserMediaScreen("", JSON.stringify({ callKind: "mixedClassAction", callData }));
}

export const callEoForRequestServerUserAuthReset = (localUserSeq, serverUserSeq) => {
    const callData = { actionKind: "requestAuthReset", localUserSeq, serverUserSeq };
    sendToBrowserMediaScreen("", JSON.stringify({ callKind: "mixedClassAction", callData }));
}

export const callEoForSendMediaScreen = (actionKind, actionData) => {
    console.log('callEoForSendMediaScreen');
    let sendKind = actionKind;
    let sendData = actionData;
    //console.log(actionKind);
    //console.log(actionData);

    sendToBrowserMediaScreen("", JSON.stringify({ callKind: sendKind, callData: sendData }));
}

export const callEoForSendGroupChatAction = (actionKind, actionData, etcData) => {
    let sendData = {
        kind: actionKind,
        data: actionData
    };

    console.log(`callEoForSendGroupChatAction -- sendData[`, sendData, `]`);
    sendToBrowserAction(JSON.stringify({ kind: 'groupChat', data: sendData }), JSON.stringify(etcData));
}

export const callEoForSendWhisperAction = (actionKind, actionData, etcData) => {
    let sendData = {
        kind: actionKind,
        data: actionData
    };

    console.log(`callEoForSendWhisperAction -- sendData[`, sendData, `], etcData[${etcData}]`);
    sendToBrowserAction(JSON.stringify({ kind: 'whisper', data: sendData}), JSON.stringify(etcData));
}

export const callEoForSendAction = (actionKind, actionData, etcData) => {
    console.log(actionKind, actionData, etcData);
    
    let sendKind = actionKind;
    let sendData = actionData;
    //console.log(actionKind);
    //console.log(actionData);

    //callEoForSendAction("message_talk", { text: msgText, emoticSeq: state.selectedEmoticonSeq, userNickname });

    if (actionKind === "groupChat") {
        const { kind, action, information, userNickname } = actionData;

        const bytesData = getSendToMQBytes({
            tokenCmd: enTokenCMD.ct_SendToWebJSonInfo,
            text: JSON.stringify({ kind, action, information }) 
        }, userNickname);

        sendKind = "sendRawData";
        // 20261015 대용량 데이터 RangeError 방지를 위해 청크 단위 base64 변환으로 교체
        sendData = bytesToBase64(bytesData.forHiclass);

        console.log("send group chat data - ", actionKind, actionData);
        sendToBrowserAction(JSON.stringify({ kind: sendKind, data: sendData }), etcData);
    } else if (actionKind === "whisperFileShare") {
        const { filename, userNickname, path } = actionData;

        const bytesData = getSendToMQBytes({
            //tokenCmd: enTokenCMD.ct_UploadAndShareFiles,
            tokenCmd: enTokenCMD.ct_SendToWebJSonInfo,
            text: JSON.stringify({
                kind: "whisper",
                action: "file_share",
                information: {
                    filename,
                    path,
                    userNickname
                }
            }),
        }, userNickname);

        // 20261015 대용량 데이터 RangeError 방지를 위해 청크 단위 base64 변환으로 교체
        sendData = bytesToBase64(bytesData.forHiclass);

        sendToBrowserAction(JSON.stringify({ kind: sendKind, data: sendData }), etcData);
    } else if (actionKind === "quiz") {
        const { kind, action, information, userNickname } = actionData;

        const bytesData = getSendToMQBytes({
            tokenCmd: enTokenCMD.ct_SendToWebJSonInfo,
            text: JSON.stringify({ kind, action, information }),
        }, userNickname);

        sendKind = "sendRawData";
        // 20261015 대용량 데이터 RangeError 방지를 위해 청크 단위 base64 변환으로 교체
        sendData = bytesToBase64(bytesData.forHiclass);

        sendToBrowserAction(JSON.stringify({ kind: sendKind, data: sendData }), etcData);
    } else if (actionKind === "audio_memo") {
        // 20261015 전송 실패 시 말풍선 실패 표시를 위한 콜백(onFail) 추가
        const { voiceData, userSeq, userNickname, onFail } = actionData;

        // 20261015 음성메모 전송 실패 처리 - 알림 표시 후 말풍선 실패 표시 콜백 호출
        const handleAudioMemoSendFail = (err) => {
            console.log("callEoForSendAction() - audio_memo send fail => ", err);
            alert(i18n.t("음성메모_전송_실패", { ns: "classTalk" }));
            if (typeof onFail === "function") {
                onFail();
            }
        };

        let reader = new FileReader();
        let array;
        reader.readAsArrayBuffer(voiceData);
        reader.onload = () => {
            // 20261015 변환/전송 중 예외가 catch되지 않아 실패해도 표시가 없던 문제 수정
            try {
                array = reader.result;
                //console.log("callEoForSendAction() - audio_memo onload");
                const bytesData =
                    getSendToMQBytes({
                        tokenCmd: enTokenCMD.chat_Voice,
                        CLASSID: 0,
                        PENID: userSeq,
                        data: array
                    }, userNickname);

                sendKind = "sendRawData";
                // 20261015 대용량 데이터 RangeError 방지를 위해 청크 단위 base64 변환으로 교체
                sendData = bytesToBase64(bytesData.forHiclass);

                //sendToBrowserAction(JSON.stringify({ kind: sendKind, data: sendData }), JSON.stringify(etcData));
                sendToBrowserAction(JSON.stringify({ kind: sendKind, data: sendData }), etcData);
            } catch (err) {
                handleAudioMemoSendFail(err);
            }
        };
        // 20261015 파일 읽기 실패 처리 추가
        reader.onerror = () => {
            handleAudioMemoSendFail(reader.error);
        };
    } else if (actionKind === "file_share") {
        console.log("call eo for FILE_SHARE -- ", actionData);
        sendToBrowserAction(JSON.stringify({ kind: actionKind, data: actionData}), JSON.stringify(etcData));
    } else {
        if (actionKind === "message_talk") {
            const { text, emoticSeq, userNickname } = actionData;
            const bytesData = getSendToMQBytes({
                tokenCmd: enTokenCMD.chat_Text,
                emoGIDno: 0,   /* 0번 고정 */
                emoMIDno: emoticSeq,
                text
            }, userNickname);
            sendKind = "sendRawData";
            // 20261015 대용량 데이터 RangeError 방지를 위해 청크 단위 base64 변환으로 교체
            sendData = bytesToBase64(bytesData.forHiclass);
        }

        //sendToBrowserAction(JSON.stringify({ kind: sendKind, data: sendData }), JSON.stringify(etcData));
        sendToBrowserAction(JSON.stringify({ kind: sendKind, data: sendData }), etcData);
    }
}

export const callEoForSendMessage = (tokenCmd, actionKind, actionData, etcData) => {
    let sendKind = actionKind;
    let sendData = actionData;
    let sendEtcData = etcData === undefined || etcData === null ? "" : etcData;
    console.log('callEoForSendMessage - ', sendKind, sendData, sendEtcData);

    if (tokenCmd === enTokenCMD.ct_SendToWebJSonInfo) {
        const { kind, action, information, userNickname } = actionData;
        const bytesData = getSendToMQBytes({
            tokenCmd: enTokenCMD.ct_SendToWebJSonInfo,
            text: JSON.stringify({ kind, action, information })
        }, userNickname);
        // 20261015 대용량 데이터 RangeError 방지를 위해 청크 단위 base64 변환으로 교체
        sendData = bytesToBase64(bytesData.forHiclass);

        sendToBrowserAction(JSON.stringify({ kind: sendKind, data: sendData }), sendEtcData);
    }
}

export const callEoForJoinChatRoom = (roomSeq, userSeq, chatRoomName, chatRoomType, members_info) => {
    const keyArr = getTeamUpBindKey(roomSeq, userSeq);
    const bindInfo = {
        action: "bind",
        infos: [
            { exchange: amqExchange.name, key: keyArr[0] },
            { exchange: amqExchange.name, key: keyArr[1] }
        ],
        topicSendKeyCC: getTeamUpSendKey(roomSeq, userSeq)
    };

    const chatRoomInfo = { chatRoomSeq: roomSeq, chatRoomName, chatRoomType };
    const callData = { membersInfo: members_info, chatRoomInfo };

    sendToBrowserMediaScreen(JSON.stringify({ bindInfo }), JSON.stringify({ callKind: "joinChatRoom", callData }));
}

export const callEoForFinishChatRoom = (roomSeq, userSeq) => {
    const keyArr = getTeamUpBindKey(roomSeq, userSeq);
    const bindInfo = {
        action: "unbind",
        infos: [
            { exchange: amqExchange.name, key: keyArr[0] },
            { exchange: amqExchange.name, key: keyArr[1] }
        ],
        topicSendKeyCC: "RESET"
    };
    const callData = { chatRoomSeq: roomSeq, userSeq };

    sendToBrowserMediaScreen(JSON.stringify({ bindInfo }), JSON.stringify({ callKind: "finishChatRoom", callData }));
}

export const callEoForUpdateChatRoomName = (roomSeq, chatRoomName) => {
    const callData = {
        chatRoomSeq: roomSeq,
        chatRoomName: chatRoomName
    };

    sendToBrowserMediaScreen("", JSON.stringify({ callKind: "updateChatRoomName", callData }));
}

export const callEoForUpdateChatRoomMemberName = (roomSeq, userSeq, userNickname) => {
    const callData = {
        chatRoomSeq: roomSeq,
        userSeq: userSeq,
        userNickname: userNickname
    };

    sendToBrowserMediaScreen("", JSON.stringify({ callKind: "updateChatRoomMemberName", callData }));
}

export const callEoForAddChatRoomMembers = (roomSeq, members_info) => {
    const callData = {
        chatRoomSeq: roomSeq,
        membersInfo: members_info
    };

    sendToBrowserMediaScreen("", JSON.stringify({ callKind: "addChatRoomMembers", callData }));
}

export const callEoForUpdateHandsUpWindowStatus = (userSeq, status) => {
    const callData = { userSeq, status };
    sendToBrowserHandsUp(JSON.stringify({ kind: "updateLiveHandsUpWindowStatus", data: callData }));
}

export const callEoForUpdateGroupStudyWindowStatus = (userSeq, status) => {
    const callData = { userSeq, status };
    sendToBrowserHandsUp(JSON.stringify({ kind: "updateLiveGroupStudyWindowStatus", data: callData }));
}

// export const callEoForUpdateHandsUpStatus = (userSeq, liveSeq, list_member, selectStatus, handsUpYN, groupLimit, startSeqOfSmartTV, binders) => {
export const callEoForUpdateHandsUpStatus = (userSeq, live_info) => {
    // const callData = { userSeq, liveSeq, list_member, selectStatus, handsUpYN, groupLimit, startSeqOfSmartTV, binders };
    const callData = { userSeq, ...live_info };
    sendToBrowserHandsUp(JSON.stringify({ kind: "updateLiveHandsUpStatus", data: callData }));
}

export const callEoForUpdateBroadcastStatus = (liveSeq, list_guest, openYN) => {
    const callData = { liveSeq, list_guest, openYN };
    sendToBrowserHandsUp(JSON.stringify({ kind: "updateBroadcastStatus", data: callData }));
}

export const toggleMediaSoupSenderCall = () => {
    sendToBrowserMediaScreen("", JSON.stringify({ callKind: "toggleSender" }));
}

export const callEoAddLiveMember = (liveSeq, member_info) => {
    const callData = {
        liveSeq,
        userSeq         : member_info.userSeq,
        userNickname    : member_info.userNickname,
        userJoinstatus  : member_info.userJoinstatus,
        liveCertiYN     : member_info.liveCertiYN,
        isInkON         : member_info.isInkON,
        isSoundON       : member_info.isSoundON,
        isScreenON      : member_info.isScreenON,
        isSelect        : member_info.isSelect,
        isPullScreen    : member_info.isPullScreen,
        isPushScreen    : member_info.isPushScreen
    };

    sendToBrowserHandsUp(JSON.stringify({ kind: "addLiveMember", data: callData }));
}

// remocon action //
export const callEoForUpdateHandsUpMemberStatus = ({ kind, memberSeqList, memberSeq, isSelect }) => {
    let callData;
    if (memberSeq !== undefined && memberSeq !== null) {
        callData = {
            userSeq: memberSeq,
            isSelect: isSelect
        };
    } else {
        callData = {
            userSeqList: memberSeqList,
            isSelect: isSelect
        };
    }

    sendToBrowserHandsUp(JSON.stringify({ kind, data: callData }));
}

export const callEoForUpdateTeamUpMemberStatus = ({ kind, memberSeqList, memberSeq, isSelect }) => {
    let callData;
    if (memberSeq !== undefined && memberSeq !== null) {
        callData = {
            userSeq: memberSeq,
            isSelect: isSelect
        };
    } else {
        callData = {
            userSeqList: memberSeqList,
            isSelect: isSelect
        };
    }

    sendToBrowserMediaScreen("", JSON.stringify({ callKind: kind, data: callData }));
}

export const callEoForSelectSoundDeviceInfo = ({ kind, command, target, value }) => {
    const callData = { kind, value, target };
    sendToBrowserDeviceInfo(JSON.stringify({ callKind: command, callData }));
}
////////////////////

const sendToBrowserAction = (data1, data2) => {
    //console.log('sendToBrowserAction - ACTION_SEND');
    if (window.hiClassTvWebApi !== undefined) {
        window.hiClassTvWebApi("ACTION_SEND", data1, data2);
    } else if (window.eoapi !== undefined && window.eoapi !== null) {
        window.eoapi.extInvoke("ACTION_SEND", [data1, data2]);
    }
}

const sendToBrowserJson = (data1, data2) => {
    console.log('sendToBrowserJson - JSON_SEND');

    if (window.hiClassTvWebApi !== undefined) {
        window.hiClassTvWebApi("JSON_SEND", data1, data2);
    } else if (window.eoapi !== undefined && window.eoapi !== null) {
        window.eoapi.extInvoke("JSON_SEND", [data1, data2]);
    }
}

const sendToBrowserMediaScreen = (data1, data2) => {
    console.log('sendToBrowserMediaScreen - MEDIA_SCREEN');
    if (window.hiClassTvWebApi !== undefined) {
        window.hiClassTvWebApi("MEDIA_SCREEN", data1, data2);
    } else if (window.eoapi !== undefined && window.eoapi !== null) {
        window.eoapi.extInvoke("MEDIA_SCREEN", [data1, data2]);
    }
}

const sendToBrowserHandsUp = (data) => {
    console.log('sendToBrowserHandsUp - HANDS_UP_SEND');
    if (window.hiClassTvWebApi !== undefined) {
        window.hiClassTvWebApi("HANDS_UP_SEND", "", data);
    } else if (window.eoapi !== undefined && window.eoapi !== null) {
        window.eoapi.extInvoke("HANDS_UP_SEND", ["", data]);
    }
}

const sendToBrowserDeviceInfo = (data) => {
    console.log('sendToBrowserDeviceInfo - MEDIA_SCREEN');
    if (window.hiClassTvWebApi !== undefined) {
        window.hiClassTvWebApi("MEDIA_SCREEN", "", data);
    } else if (window.eoapi !== undefined && window.eoapi !== null) {
        window.eoapi.extInvoke("MEDIA_SCREEN", ["", data]);
    }
}